



























import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import AddOffice from "./office/add-office.vue";
import BindCloud from "./office/bind-cloud.vue"
import PageRequest from "@/store/entities/page-request";
class PageOfficeRequest extends PageRequest {
  keyword: string;
}

@Component({ components: { AddOffice, BindCloud } })
export default class Office extends AbpBase {
  addOfficeModal: boolean = false;
  bindCloudModal: boolean = false;
  pagerequest: PageOfficeRequest = new PageOfficeRequest();
  admins: Array<any> = [];

  get list() {
    return this.$store.state.office.list;
  }
   get pageSize() {
    return this.$store.state.office.pageSize;
  }
  get totalCount() {
    return this.$store.state.office.totalCount;
  }
  get currentPage() {
    return this.$store.state.office.currentPage;
  }
  pageChange(page: number) {
    this.$store.commit("office/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("office/setPageSize", pagesize);
    this.getpage();
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "office/getAll",
      data: this.pagerequest,
    });
  }
  async getAdmins() {
    this.admins = await this.$store.dispatch({
      type: "user/getAdmins",
    });
  }
  bindCloud(item:any){
    (this.$refs.bindCloudForm as any).init(item.id);
    this.bindCloudModal = true;
  }

  create() {
    (this.$refs.addOfficeForm as any).init(this.admins);
    this.addOfficeModal = true;
  }

  async disable(item) {
    await this.$store.dispatch({
      type: "office/disable",
      data: {
        id: item.id,
        disable: !item.disable
      }
    })
    this.$Message.success(this.L("SuccessAction"));
    this.getpage();
  }

  async created() {
    this.getpage();
    this.getAdmins();
  }

  columns = [
    {
      title: this.L("OfficeName"),
      key: "name",
    },
    {
      title: this.L("MemberCount"),
      key: "count",
    },
    {
      title: this.L("DingTalk"),
      key: "isDingTalk",
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isDingTalk
            ? this.L("Yes")
            : this.L("No")            
        );
      }
    },
    {
      title: this.L("BindCloud"),
      key: "platformSource"
    },
    {
      title: this.L("Admins"),
      key: "admins",
    },
    {
      title: this.L("Address"),
      key: "address",
    },
    {
      title: this.L("Remark"),
      key: "remark",
    },
    {
      title: this.L("Disable"),
      key: "disable",
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.disable == 0
            ? this.L("Enable")
            : this.L("Disable")            
        );
      }
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 220,
      render: (h: any, params: any) => {
        return h("div", [
           h(
            "Button",
            {
              props: {
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.bindCloud(params.row);                  
                },
              },
            },
           this.L("BindCloud")
          ),
          h(
            "Button",
            {
              props: {
                type: params.row.disable == 0 ? "primary" : "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.disable(params.row);                  
                },
              },
            },
           params.row.disable == 0 ? this.L("Disable") : this.L("Enable")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "office/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
}
